import React from 'react'

const EmptyState = () => {
  return (
  <div className="bg-white/90 border border-slate-200/80 rounded-2xl shadow-xl p-5">
    <h2 className="text-lg font-semibold mb-2">Start by searching for a product</h2>
    <p className="text-sm text-slate-600">
      Type the name of a phone, TV, or home appliance above and we'll show you
      in-store offers near your selected area.
    </p>
  </div>
  )
}

export default EmptyState
